import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthEvent, AuthService } from '@michelin/auth';

export const THOUSAND = 1000;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationWrapperService {
  endpoint = 'authentication/authorize';

  onLoginRequired$ = new Subject<void>();
  onLoginSuccess$ = new Subject<User>();
  onLogoutSuccess$ = new Subject<void>();
  onSessionExpired$ = new Subject<void>();

  /**
   * Constructor
   *
   * @param authService authService
   * @param userService userService
   */
  constructor(private readonly authService: AuthService) {
    this.authService.events
      .pipe(
        filter((e: AuthEvent) => {
          return e.type === 'token_received';
        })
      )
      .subscribe((_) => {
        if (sessionStorage.getItem('logged') !== 'true') {
          sessionStorage.setItem('logged', 'true');
          // if you have an endpoint to get user details call it here
          this.onLoginSuccess$.next(null);
        }
      });
  }

  /**
   * Logout
   */
  public logout(router?: Router): void {
    sessionStorage.setItem('logoutRedirectTo' , router ? router.url : 'loggedout');
    sessionStorage.removeItem('logged');
    this.authService.logOut();
  }

  /**
   * Unauthorized
   */
  unauthorized() {
    sessionStorage.setItem('unauthorized', 'unauthorized');
    this.logout();
  }

  /**
   * Get the user token
   */
  public getToken(): string {
    return this.authService.getIdToken();
  }

  /**
   * If the user is authenticated
   */
  public isAuthenticated(): boolean {
    return this.authService.hasValidAccessToken();
  }
}
